import { render, staticRenderFns } from "./Edit-dose.vue?vue&type=template&id=4a5f6203&scoped=true&"
import script from "./Edit-dose.vue?vue&type=script&lang=js&"
export * from "./Edit-dose.vue?vue&type=script&lang=js&"
import style0 from "./Edit-dose.vue?vue&type=style&index=0&id=4a5f6203&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5f6203",
  null
  
)

export default component.exports